import React from "react";
import minusIcon from "../svg/minusIcon.svg";

const MinusIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 -20 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 2H23.5"
      stroke="#0F191A"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MinusIcon;
